<!-- @format -->

<span>
  @if (resolvedEnrolmentRightState === "ACTIVATED_FUTURE") {
    <span data-cy="enrolment-right-is-activated-label" class="tiny-badge secondary">
      {{ "ENROLMENT_RIGHT_RESOLVED_STATE.ACTIVATED_FUTURE" | translate }}
    </span>
  }

  @if (resolvedEnrolmentRightState === "ACTIVATED_ACTIVE") {
    <span data-cy="enrolment-right-is-activated-label" class="tiny-badge success">
      {{ "ENROLMENT_RIGHT_RESOLVED_STATE.ACTIVATED_ACTIVE" | translate }}
    </span>
  }

  @if (resolvedEnrolmentRightState === "ACTIVATED_EXPIRED") {
    <span data-cy="enrolment-right-is-expired-label" class="tiny-badge secondary">
      {{ "ENROLMENT_RIGHT_RESOLVED_STATE.ACTIVATED_EXPIRED" | translate }}
    </span>
  }

  @if (resolvedEnrolmentRightState === "CANCELLED") {
    <span data-cy="enrolment-right-is-cancelled-label" class="tiny-badge danger">
      {{ "ENROLMENT_RIGHT_RESOLVED_STATE.CANCELLED" | translate }}
    </span>
  }

  @if (isSubstitutionRight) {
    <span class="tiny-badge primary">
      {{ "ENROLMENT_RIGHT_TYPE.SUBSTITUTION" | translate }}
    </span>
  }
</span>
